import {promiseRequest} from '../util/promiseRequest'
import {GeoIp} from '@/types/models'

export function getGeoIp() {
  return promiseRequest<GeoIp>(`https://api.${process.env.host}/v1/geoip/country`)
}
